// extracted by mini-css-extract-plugin
export default {"transaction_img":"style_transaction_img__DMZJ-","Tel":"style_Tel__NH8Pp","btnWhy":"style_btnWhy__J4uuB"};